<div>
  <nha-popup [isClick]="true" [isDarkBG]="true" [offsetX]="5" [offsetY]="5" class="dark-theme">
    <nha-avatar
      type="staff"
      size="25"
      [guid]="userGuid"
      popup-target
      [indicator]="isImpersonating ? 'group' : ''"
      [indicatorMessage]="isImpersonating ? 'Impersonating ' + impersonationUser : ''"
    ></nha-avatar>
    <div popup-content class="nha-user-profile-menu-info" nhaTest="nha-user-popup">
      <div class="nha-user">
        <nha-avatar type="staff" size="25" [guid]="userGuid" popup-target></nha-avatar>
        <div class="username" nhaTest="user-name">
          {{ fullName }}
          @if (isImpersonating) {
            <div class="acting-as">as {{ impersonationUser }}</div>
          }
        </div>
        <div class="job-title" nhaTest="job-title">{{ jobTitle }}</div>
      </div>
      @if (canImpersonate) {
        <div *ifHasEntitlement="'Core:Feature|Admin:Access'" class="impersonation-user">
          @if (!isImpersonating) {
            <input type="text" placeholder="Impersonation Username" [formControl]="userSearch" />
            <button class="impersonate-begin-btn" mat-flat-button matTooltip="Impersonate User" (click)="impersonateUser()">
              <mat-icon>group</mat-icon>
            </button>
          }
        </div>
        @if (isImpersonating) {
          <div class="impersonation-user">
            <button class="impersonate-end-btn" mat-raised-button color="primary" (click)="endImpersonationSession()">End Impersonation Session</button>
          </div>
        }
      }
      <button class="okta-btn" mat-raised-button color="primary" (click)="killOktaSession()" *ifHasEntitlement="'Core:Feature|Admin:Access'">
        Kill Okta Session
      </button>
      <button class="refresh-btn" mat-raised-button color="primary" (click)="refreshToken()" *ifHasEntitlement="'Core:Feature|Admin:Access'">
        Refresh Token
      </button>
      <button class="signout-btn" mat-raised-button color="primary" (click)="signOut()">Sign Out</button>
    </div>
  </nha-popup>
</div>
